"use client";

import { Check } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Comprehensive Interior & Exterior",
  description: "Complete perimeter defense and targeted interior treatments to keep pests out of your home year-round."
}, {
  title: "100% Re-Treatment Guarantee",
  description: "If pests return between your scheduled visits, we'll come back and re-treat your property at no extra cost."
}, {
  title: "FDACS Licensed & Fully Insured",
  description: "Rest easy knowing your property is protected by certified professionals meeting all Florida state regulations."
}, {
  title: "Local Punta Gorda Experts",
  description: "We know Southwest Florida's unique pest challenges, from Port Charlotte to Cape Coral, and how to beat them."
}, {
  title: "Family & Pet-Friendly Methods",
  description: "We use targeted, responsible application methods that prioritize the safety of your loved ones and pets."
}, {
  title: "Rapid Response Times",
  description: "Pest emergencies don't wait. We offer prompt scheduling and fast service to resolve your issues quickly."
}];
export default function PestControlFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="pestcontrolfeatures" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground uppercase tracking-wide mb-6">
            Why Choose Peace River
          </h2>
          <p className="text-lg md:text-xl text-foreground/80 font-serif">
            We deliver uncompromising pest control solutions built on reliability, safety, and guaranteed results for our local community.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-primary text-primary-foreground rounded-none border-none shadow-2xl hover:-translate-y-2 transition-transform duration-300">
              <CardHeader className="pb-4 flex flex-row items-start gap-4 space-y-0">
                <div className="shrink-0 w-14 h-14 bg-background flex items-center justify-center [clip-path:polygon(30%_0%,_70%_0%,_100%_30%,_100%_70%,_70%_100%,_30%_100%,_0%_70%,_0%_30%)]">
                  <Check className="w-8 h-8 text-foreground stroke-[3]" />
                </div>
                <CardTitle className="font-default text-xl md:text-2xl leading-tight pt-1">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-primary-foreground/80 font-serif text-base md:text-lg leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-full text-lg px-8 py-6 font-default uppercase tracking-wider shadow-xl hover:scale-105 transition-transform">
            <Link to="/ContactPage">
              Schedule Free Inspection
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}